'use strict';

export default class EditController {

  /*@ngInject*/
  constructor($http, $state, $stateParams) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
  }

  $onInit() {
    this.getData(this.$stateParams.id);
  }

  getData(id) {
    this.$http.get(`/api/myscripts/${id}`).then(res => {
      this.data = res.data;
    });
  }

  update() {
    this.$http.put(`api/myscripts/${this.$stateParams.id}`, this.data).then(res => {
      this.$state.go('myscripts.list');
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/myscripts/edit/edit.controller.js